import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Balance from "./components/Balance";
import Form from "./components/Form";
import Layout from "./components/Layout";
import Transactions from "./components/Transactions/Transactions";
import Home from "./Home";

function App() {
    return (
        <Router>
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/trackers" element={<Home />} />
            </Routes>
        </Router>
    );
}

export default App;
